import { render, staticRenderFns } from "./ValidateIssue.vue?vue&type=template&id=337583fe&scoped=true&"
import script from "./ValidateIssue.vue?vue&type=script&lang=js&"
export * from "./ValidateIssue.vue?vue&type=script&lang=js&"
import style0 from "./validateIssue.scss?vue&type=style&index=0&id=337583fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337583fe",
  null
  
)

export default component.exports